import $ from 'jquery';
import 'owl.carousel';

$(window).on('load', function() {

  $('header .hamburger').on('click', function() {
    $('html').addClass('scroll-none');
    $('header .nav-main').addClass('open');
  });

  $('header .nav-main .close-btn').on('click', function() {
    $('html').removeClass('scroll-none');
    $(this).parents('.nav-main').removeClass('open');
  });

  // MODAL FONDO DE NUBES

  $('.modal-trigger a').on('click', function(e) {
    e.preventDefault();
    $('html').addClass('scroll-none');
    $('.clouds-modal').addClass('open');
  })

  $('.clouds-modal .close-btn').on('click', function() {
    $('html').removeClass('scroll-none');
    $(this).parents('.clouds-modal').removeClass('open');
    $(this).parents('.clouds-modal').find('.wrapper').scrollLeft(0);
    $(this).parents('.clouds-modal').find('.bg').css('transform', 'translateX(0)');
  });

  // MODAL PRINCIPIOS

  $('.box-buttons .box').on('click', function() {
    $('html').addClass('scroll-none');
    let slide = $(this).data('principle');
    $('.principles .principle-modal').trigger('to.owl.carousel', slide - 1);
    setTimeout(() => {
      $('.principles').addClass('open');
    }, 200);
  });

  $('.principles .principle-modal').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    navContainer: '.principle-modal-nav',
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
    dots: false,
    mouseDrag: false,
  });

  $('.principles .principle-modal .owl-prev, .principles .principle-modal .owl-next').on('click', function() {
    $(this).parents('.principles').removeClass('open');
    setTimeout(() => {
      $(this).parents('.principles').addClass('open');
    }, 200);
  });

  $('.principles .close-btn').on('click', function() {
    $('html').removeClass('scroll-none');
    $('.principles').removeClass('open');
    $('.principles .principle-modal').trigger('to.owl.carousel', 1);
  });

  // MODAL ELEMENTOS PARA TRABAJAR

  $('.box-buttons-with-images .box').on('click', function() {
    $('html').addClass('scroll-none');
    let slide = $(this).data('element');
    $('.elements .element-modal').trigger('to.owl.carousel', slide - 1);
    setTimeout(() => {
      $('.elements').addClass('open');
    }, 200);
  });

  $('.elements .element-modal').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    navContainer: '.element-modal-nav',
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
    dots: false,
    mouseDrag: false,
  });

  $('.elements .owl-prev, .elements .owl-next').on('click', function() {
    $(this).parents('.elements').removeClass('open');
    setTimeout(() => {
      $(this).parents('.elements').addClass('open');
      $(this).parents('.elements').find('.element-modal').scrollTop(0);
    }, 200);
  });

  $('.elements .close-btn').on('click', function() {
    $('html').removeClass('scroll-none');
    $('.elements').removeClass('open');
    $('.elements .element-modal').trigger('to.owl.carousel', 1);
  });

  // ACCORDION

  $('.accordion-with-editor .item').on('click', function() {
    $('.accordion-with-editor .item').not(this).removeClass('active');
    $(this).toggleClass('active');
    $(this).find('.acc-text').slideToggle(500);
    $('.accordion-with-editor .item').not(this).find('.acc-text').slideUp(500);
    //$('.element-modal .owl-height').trigger('refresh.owl.carousel');
  });

  // MODAL PASOS 1 AL 6

  $('.image-with-links .link').on('click', function() {
    $('html').addClass('scroll-none');
    let step = $(this).data('step');
    $('.steps .step-modal').trigger('to.owl.carousel', step - 1);
    setTimeout(() => {
      $('.steps').addClass('open');
    }, 500);
  });

  $('.steps .step-modal').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    autoHeight: true,
    navContainer: '.step-modal-nav',
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
    dots: false,
    mouseDrag: false,
  });

  $('.steps .owl-prev, .steps .owl-next').on('click', function() {
    $(this).parents('.steps').removeClass('open');
    setTimeout(() => {
      $(this).parents('.steps').addClass('open');
      $(this).parents('.steps').find('.step-modal').scrollTop(0);
    }, 200);
  });

  $('.steps .close-btn').on('click', function() {
    $('html').removeClass('scroll-none');
    $('.steps').removeClass('open');
    $('.steps .step-modal').trigger('to.owl.carousel', 1);
  });

  // MODAL ENCUESTA

  $('.cta-button a').on('click', function(e) {
    e.preventDefault();
    $('.survey').addClass('open');
  })

  $('.survey .close-btn').on('click', function() {
    $(this).parents('.survey').removeClass('open');
  });

  // MEDIA QUERIES

  if($(window).width() > 1024) {

    $('header .nav-main .menu-item-has-children').on('mouseenter', function() {
      let scrollTop = $(window).scrollTop(),
      elementOffset = $(this).offset().top,
      distance = (elementOffset - scrollTop);
      $(this).find('ul').css('padding-top', distance);
    });

    $('.clouds-modal .wrapper').on('scroll', function() {
      $('.clouds-modal .bg').css('transform', 'translateX(' + $(this).scrollLeft() * -1.5 + 'px)');
    })

  }

  if($(window).width() <= 1024) {
    $('header .nav-main .menu-item-has-children').on('click', function() {
      $('header .nav-main .menu-item-has-children').not(this).removeClass('open');
      $(this).toggleClass('open');
    });

    $('.fixed-menu .main-btn').on('click', function() {
      $(this).parents('.fixed-menu').addClass('active');
    })

    $(document).on('click', function(event) {
      if(!$(event.target).closest('.fixed-menu').length){
          $('.fixed-menu').removeClass('active');
      }
    });

    /*$('.elements .accordion-with-editor .item').on('click', function() {
      let accTextTop = $(this).find('.acc-title').innerHeight();
      $(this).find('.acc-text').css('top', accTextTop);
    });*/
  }
});

let isSurveyForm = false;
$('.survey-form').on('submit', function() {
  $('.ajax-message').text('').hide();
  $('.thanks').hide();

  if (isSurveyForm) return;
  isSurveyForm = true;

  let form = $(this);
  let formData = new FormData(this);
  
  fetch($(this).attr('action'), {
      method: $(this).attr('method'),
      body: formData
  })
  .then(function (response) {
      return response.json();
  }).then(function (response) {
      if (response.success) {
          form.trigger('reset');
          $('.thanks').show();

      } else if (typeof response.data.message !== 'undefined') {
          $('.ajax-message').text(response.data.message).show();
      }
      
      isSurveyForm = false;
  }).catch(function (err) {
      isSurveyForm = false;
  });
});